// Helper to get the current language code for legal/policy pages
export function useLegalLang(i18n) {
  const lang = i18n.language?.split('-')[0] || 'en';
  const supported = ['en', 'es', 'de', 'nl', 'fr', 'ar'];
  return supported.includes(lang) ? lang : 'en';
}

// Multi-language text lookup: pass an object { en: '...', es: '...', de: '...', ... }
// Returns the correct language text or falls back to English
export function lt(langTexts, lang) {
  return langTexts[lang] || langTexts.en || '';
}
